import styles from './appbar.module.scss';
import { useParams, useRouter } from 'next/navigation';
import { useConsole, useUser } from 'contexts';
import Routes, { appbarRoutes } from 'data/routes';
import { Flex, IconButton } from 'ui';
import { useState } from 'react';
import Menu from './Drawer';

const Appbar = () => {
  const { currentPath, screen } = useConsole();
  const [open, setOpen] = useState(false);
  const { profile } = useUser();
  const params = useParams();
  const router = useRouter();

  if (!screen.isMobile || (params?.bid && screen.isMobile)) return null;

  return (
    <Flex className={styles.root} component="nav" justifyContent="center">
      <Flex component="ul" justifyContent="space-around">
        {appbarRoutes.map(({ href, icon, activePaths }) => (
          <IconButton
            key={href}
            active={!open && activePaths?.includes(currentPath)}
            color="inherit"
            component="li"
            icon={icon}
            onClick={() => {
              router.push(href);
              setOpen(false);
            }}
            rounded
          />
        ))}
        <IconButton
          active={open}
          hidden={!profile.name}
          icon="menu"
          onClick={() => setOpen(!open)}
          rounded
        />
        <IconButton
          active={currentPath?.includes(Routes.login)}
          hidden={profile.name}
          icon="account_circle"
          onClick={() => {
            router.push(Routes.login);
            setOpen(false);
          }}
          rounded
        />
        <Menu open={open} onClose={() => setOpen(false)} />
      </Flex>
    </Flex>
  );
};

export default Appbar;
